import { newApiInstance } from 'functions/request';

const entity = '/my/bonuses';

export const notify = id => newApiInstance.post(`${entity}/${id}/mark_as_shown`);
